
<template></template>

<script>
import api from "@/api"
import config from "@/config"
import {mapActions} from "vuex"
export default {
  //for azure ad login
  created() {
    if (!this.$msal.isAuthenticated()) {
      this.loginFail();
      //  this.$router.push("/");
    } else {
      api.request(
        this,
        "post",
        "/system/authenticate",
        {
          SessionID: null,
          LocaleCode: config.defaultLocale,
          Parameters: {
            method: "AD",
            username: this.$msal.data.user.userName,
            password:null,
            isAuthenticated:this.$msal.isAuthenticated()
          }
        },
        function(r) {
          this.loginSuccess(r);
        },
        function(r) {
          // this.loginFail(r);
        }
      );
    }
  },
  methods: {
    ...mapActions(["actionSetToken", "actionSetMessage", "actionSetUser"]),
    loginSuccess(r) {
      console.log(r);
      if (r.code === 200) {
        console.log(r.data.user_profile);
        this.actionSetUser(r.data.user_profile);
        this.actionSetToken(r.data.session_id);
        console.log(r.data.session_id);
        // Support refresh
        if (window.localStorage) {
          // window.localStorage.setItem(
          //   "ccrs_user",
          //   JSON.stringify(r.data.user_profile)
          // );
          // window.localStorage.setItem("ccrs_token", r.data.session_id);
        }

        if (this.$route.query.redirect) {
          this.$router.push(this.$route.query.redirect);
        } else {
          this.$router.push("/");
        }
        // this.$router.go(0);
      } else {
        this.message = r.message;
        this.msg = this.message;
        this.wrongpassword = true;
        this.$router.push("/logout");
      }
    },
    loginFail(r) {
      this.$router.push("/logout");
    }
  }
};
</script>

<style>
</style>